import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { KreuzfahrtFilters } from '@app/models/filtermodels/KreuzfahrtFilters';
import { CruiseFiltersService } from '@app/services/cruis/cruisefilters.service';
import { Subject, takeUntil } from 'rxjs';
import { cruisesearchTypes, cruisegsPrice, cruisecabinCat, cruiselanguage, cruisemaxPass, cruisereiseDauer } from '../../tools/CruiseStatic';

interface Item {
    name: string;
    function: string;
    index?: number,
    field?: string;
}

@Component({
    selector: 'clever-cruiseselectedfilters',
    templateUrl: './cruiseselectedfilters.component.html',
    styleUrls: ['./cruiseselectedfilters.component.scss'],
    standalone: false
})
export class CruiseselectedfiltersComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() isDisabled: boolean = false;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    list: Item[] = [];
    filter: KreuzfahrtFilters;
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected cruiseFilterService: CruiseFiltersService,
        protected cdr: ChangeDetectorRef,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    initFilterSub(): void {
        this.cruiseFilterService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: KreuzfahrtFilters) => {
            if (filter) {
                this.checkFilters(filter);
            }
        });
    }

    checkFilters(filter): void {
        this.list = [];
        this.cdr.markForCheck();
        this.filter = JSON.parse(JSON.stringify(filter));
        this.checlpromo();
        this.checkSearchType('cruisesuchetype', cruisesearchTypes);
        this.checkSearchType('cruiseduration', cruisereiseDauer);
        this.checkSearchType('cruiseboardlanguage', cruiselanguage);
        this.checkSearchType('cruisemaxprice', cruisegsPrice);
        this.checkSearchType('cruisecabincat', cruisecabinCat);
        this.checkSearchType('cruisemaxanzpass', cruisemaxPass);
        if (this.filter?.schiffes?.length > 0) {
            this.filter.schiffes.forEach((ship, index) => {
                this.list.push({
                    name: ship.name,
                    function: 'removeship',
                    index,
                    field: 'schiffes'
                });
            });
        }
        if (this.filter?.cruiseregion?.length > 0) {
            this.filter.cruiseregion.forEach((region, index) => {
                this.list.push({
                    name: region.name,
                    function: 'removecruiseregion',
                    index,
                    field: 'cruiseregion'
                });
            });
        }

        if (this.filter?.cruisecompanys?.length > 0) {
            this.filter.cruisecompanys.forEach((company, index) => {
                this.list.push({
                    name: company.name,
                    function: 'removecruisecompanys',
                    index,
                    field: 'cruisecompanys'
                });
            });
        }

        if (this.filter?.cruisestarthafen?.length > 0) {
            this.filter.cruisestarthafen.forEach((port, index) => {
                this.list.push({
                    name: port.name,
                    function: 'removecruisestarthafen',
                    index,
                    field: 'cruisestarthafen'
                });
            });
        }

        if (this.filter?.cruisezielhafen?.length > 0) {
            this.filter.cruisezielhafen.forEach((port, index) => {
                this.list.push({
                    name: port.name,
                    function: 'removecruisezielhafen',
                    index,
                    field: 'cruisezielhafen'
                });
            });
        }

        if (this.filter?.airports?.length > 0) {
            this.filter.airports.forEach((airport, index) => {
                this.list.push({
                    name: airport.name,
                    function: 'removeairports',
                    index,
                    field: 'airports'
                });
            });
        }

        this.cdr.markForCheck();
        this.cruiseFilterService.setExtraCount(this.list.length);
    }

    async resetAll() {
        this.cruiseFilterService.resetAllExtras();
    }
    async removecruiseregion(index: number) {
        if (Array.isArray(this.filter.cruiseregion)) {
            this.filter.cruiseregion.splice(index, 1);
            this.cruiseFilterService.cruiseregion(this.filter.cruiseregion);
            this.cruiseFilterService.changeUrl();
        }
    }

    async removecruisecompanys(index: number) {
        if (Array.isArray(this.filter.cruisecompanys)) {
            this.filter.cruisecompanys.splice(index, 1);
            this.cruiseFilterService.cruisecompanys(this.filter.cruisecompanys);
            this.cruiseFilterService.changeUrl();
        }
    }

    async removecruisestarthafen(index: number) {
        if (Array.isArray(this.filter.cruisestarthafen)) {
            this.filter.cruisestarthafen.splice(index, 1);
            this.cruiseFilterService.cruisestarthafen(this.filter.cruisestarthafen);
            this.cruiseFilterService.changeUrl();
        }
    }

    async removecruisezielhafen(index: number) {
        if (Array.isArray(this.filter.cruisezielhafen)) {
            this.filter.cruisezielhafen.splice(index, 1);
            this.cruiseFilterService.cruisezielhafen(this.filter.cruisezielhafen);
            this.cruiseFilterService.changeUrl();
        }
    }

    async removeairports(index: number) {
        if (Array.isArray(this.filter.airports)) {
            this.filter.airports.splice(index, 1);
            this.cruiseFilterService.airports(this.filter.airports);
            this.cruiseFilterService.changeUrl();
        }
    }


    checlpromo(): void {
        if (this.filter?.promo?.length > 0) {
            this.list.push({
                name: this.filter?.promo,
                function: 'removepromo',
            });
        }
    }

    async removepromo() {
        this.filter.promo = '';
        this.filter.pmc = '';
        this.cruiseFilterService.promo('');
        this.cruiseFilterService.pmc('');
        this.cruiseFilterService.changeUrl();
    }

    checkSearchType(type, array): void {
        if (this.filter?.[type]?.length > 0) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].id === this.filter[type]) {
                    this.list.push({
                        name: array[i].name,
                        function: 'remove' + type,
                    });
                }
            }
        }
    }

    async removecruisesuchetype() {
        this.filter.cruisesuchetype = '';
        this.cruiseFilterService.cruisesuchetype('', true);
    }

    async removecruiseduration() {
        this.filter.cruiseduration = '';
        this.cruiseFilterService.cruiseduration('', true);
    }
    async removeship(index: number) {
        if (Array.isArray(this.filter.schiffes)) {
            this.filter.schiffes.splice(index, 1);
            this.cruiseFilterService.schiffes(this.filter.schiffes, this.mode !== 'home');
        }
    }


    async removecruisemaxprice() {
        this.filter.cruisemaxprice = '';
        this.cruiseFilterService.cruisemaxprice('', true);
    }

    async removecruisemaxanzpass() {
        this.filter.cruisemaxanzpass = '';
        this.cruiseFilterService.cruisemaxanzpass('', true);
    }

    async removecruisecabincat() {
        this.filter.cruisecabincat = '';
        this.cruiseFilterService.cruisecabincat('', true);
    }

    async removecruiseboardlanguage() {
        this.filter.cruiseboardlanguage = '';
        this.cruiseFilterService.cruiseboardlanguage('', true);
    }
}
